// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"767ac8ac","787":"4bd8093e","815":"4b68497c"}[chunkId] + ".chunk.js";
};